// src/pages/autopilot/AutoPilot.js
import React, { useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DashboardLayout from '../../layout/DashboardLayout';
import ProgressTracker from '../../components/autopilot/ProgressTracker';
import IntentInput from './IntentInput';
import ICPValidation from './ICPValidation';
import SearchProgress from './SearchProgress';
import ResultsReview from './ResultsReview';
import ListCreation from './ListCreation';
import {
  setCurrentStep,
  goToNextStep,
  goToPreviousStep,
  resetAutoPilot
} from '../../store/slices/autoPilotSlice';

function AutoPilot() {
  const dispatch = useDispatch();
  const { currentStep } = useSelector((state) => state.autoPilot);

  useEffect(() => {
    // Reset Auto Pilot state when component unmounts
    return () => {
      // Only reset if user navigates away, not on step changes
    };
  }, []);

  const handleNext = () => {
    dispatch(goToNextStep());
  };

  const handleBack = () => {
    dispatch(goToPreviousStep());
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <IntentInput onNext={handleNext} />;
      case 2:
        return <ICPValidation onNext={handleNext} onBack={handleBack} />;
      case 3:
        return <SearchProgress onNext={handleNext} onBack={handleBack} />;
      case 4:
        return <ResultsReview onNext={handleNext} onBack={handleBack} />;
      case 5:
        return <ListCreation onBack={handleBack} />;
      default:
        return <IntentInput onNext={handleNext} />;
    }
  };

  return (
    <DashboardLayout pageName="Auto Pilot">
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, color: '#1BE885' }}>
            Auto Pilot
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', maxWidth: 600, mx: 'auto' }}>
            Automate your prospect search from intent to curated list creation. Reduce search time from 40 minutes to 5 minutes.
          </Typography>
        </Box>

        <ProgressTracker currentStep={currentStep} />

        <Box sx={{ mt: 4 }}>
          {renderStep()}
        </Box>
      </Container>
    </DashboardLayout>
  );
}

export default AutoPilot;
